import styled from "styled-components";
import { getStepStatus, WorkingSettingsStepperProps, WorkingSettingsStepStatus } from "../../assets/utils/enums/settings";
import { useEffect, useState } from "react";
import { COLORS } from "../../assets/utils/enums/colors";
import stepDoneIcon from '../../assets/images/icons/step-done-icon.svg';
import { LittleSubHeadline, LittleText } from "../typography";
import { useNavigate } from "react-router-dom";

export default function Stepper({ steps, activeStepId }: WorkingSettingsStepperProps) {
    const [maxReachedStep, setMaxReachedStep] = useState<number>(1);
    const progressPercent =
        ((activeStepId) / (steps.length)) * 100;
    const navigate = useNavigate();

    function goToStep(stepId: number) {
        const step = steps.find(x => x.id === stepId);
        if (!step) return;

        if (step.id > maxReachedStep + 1) return;

       // setActiveStepId(stepId);
        navigate(`/onboarding/${step.path ?? "name"}`)
    }


    useEffect(() => {
        setMaxReachedStep(prev =>
            Math.max(prev, activeStepId)
        );
    }, [activeStepId]);


    return (
        <StepperWrapper>
            <ProgressBase />
            <ProgressActive $percent={progressPercent} />

            <Steps>
                {steps.map((step) => {
                    const status = getStepStatus(step.id, activeStepId);

                    return (
                        <Step
                            key={step.id}
                            onClick={() => goToStep(step.id)}
                            style={{
                                cursor: step.id <= maxReachedStep ? "pointer" : "default",
                            }}
                        >
                            <Circle $status={status}>
                                {status === "completed" ? <img src={stepDoneIcon} alt="step-done-icon" /> : <LittleSubHeadline>{step.id.toString().padStart(2, "0")}</LittleSubHeadline>}
                            </Circle>

                            <Title $status={status}>{step.title}</Title>
                            <Subtitle>{step.subtitle}</Subtitle>
                        </Step>
                    );
                })}

            </Steps>
        </StepperWrapper>
    );
}

export const StepperWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: 16px;
`;

export const ProgressBase = styled.div`
  position: absolute;
  top: 35px;
  left: 0;
  right: 0;
  height: 3px;
  border-radius: 2px;
  background: ${COLORS["light-gray"]};
  `;

export const ProgressActive = styled.div<{ $percent: number }>`
  position: absolute;
  top: 35px;
  border-radius: 2px;
  left: 0;
  height: 3px;
  background: ${COLORS.blue};
  width: ${({ $percent }) => `${$percent}%`};
  z-index: 1;
  transition: width 0.4s ease;
`;


export const Steps = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 10;
`;

export const Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;
  cursor: pointer;
  z-index: 999;
`;

export const Circle = styled.div<{ $status: WorkingSettingsStepStatus }>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  transition: all 0.3s ease;

  ${({ $status }) => {
        switch ($status) {
            case "completed":
                return `
          background: ${COLORS["light-blue"]};
          color: ${COLORS.white};
          border: 1px solid ${COLORS.blue};
        `;
            case "active":
                return `
          background: #5b7cff;
          color: #fff;
          box-shadow: 0 0 0 6px rgba(91,124,255,0.2);
        `;
            default:
                return `
          background: ${COLORS.white};
          border: 2px solid ${COLORS.gray};
          color: ${COLORS["bg-text-color"]};
        `;
        }
    }}
`;


export const Title = styled(LittleSubHeadline) <{ $status: WorkingSettingsStepStatus }>`
  margin-top: 12px;
  
  text-align: center;
  color: ${({ $status }) => ($status === "active" ? COLORS.blue : $status === "completed" ? COLORS.secondary1 : COLORS["bg-text-color"])};
  transition: color 0.3s ease;
  ${({ $status }) => $status === "active" ? `font-weight: 650;` : ""
    }

`;

export const Subtitle = styled(LittleText)`
  margin-top: 4px;
  text-align: center;
  color: ${COLORS["bg-text-color"]};
  white-space: nowrap;
`;
